export const LIFESTYLE_GENERATION_POLLING_INTERVAL = 5000;
